window.sq = window.sq || {};

window.addEventListener("DOMContentLoaded", function () {
  // configure filter button functionality
  window.sq.configureFilterBtn();
});

window.sq.configureFilterBtn = function () {
  const btnFilter = document.querySelector("#sq-btn-filter");
  console.log("button filter is", btnFilter);
  // if either the button or sidebar is not avilable, quit!
  if (!btnFilter) return;

  btnFilter.addEventListener("click", window.sq.toggleSidebar);
};

window.sq.toggleSidebar = function () {
  const body = document.querySelector("body");
  const cssClass = "sq-open-filter";
  const sidebar = document.querySelector(".sq-filter-sidebar");
  const overlay = document.querySelector(".sq-overlay");
  if (!sidebar) return;

  body.classList.toggle(cssClass);
  sidebar.classList.toggle(cssClass);
  overlay.classList.toggle(cssClass);
};

window.sq.onComplete = function (el, opts) {
  window.sq.filterConditions(el,opts);
  window.sq.searchQuery(el);
  window.sq.filterRemove(el,opts);
  window.sq.searchheadRemove(el,opts);
};

window.sq.searchQuery = (el) => {
  let queryString = window.location.search;
  let parameters = new URLSearchParams(queryString);
  let type = parameters.get("q")
    let searchKey = el.querySelector(".sq-search-keywords-fof");
  if(searchKey != null){
      searchKey.innerHTML = type;
  }
}

window.sq.filterConditions = (el,opts) => {
    // do not run for dropdown
    if (opts.UIType === "dropdown") return;

    // setup initial elements
    const sidebar = el.querySelector(".sq-filter-sidebar");
    const filterWrapper = el.querySelector(".sq-filters-wrapper");
  
    let overlay = el.querySelector(".sq-overlay");
    let btnApply = el.querySelector(".sq-btn-apply");
    let filterCrossBtn = el.querySelector(".sq-close");
  
    let btnFilter = document.querySelector("#sq-btn-filter");
    let sqContainer = el.querySelector(".sparq-container-fluid");
  
    // add overlay only if its not added already
    if (sidebar && !overlay) {
      // insert the overlay class
      sidebar.insertAdjacentHTML("afterend", "<div class='sq-overlay'></div>");
    }
  
    if (sidebar && !filterCrossBtn) {
      // add the close button in the sidebar
      sidebar.insertAdjacentHTML("afterbegin", "<div class='sq-close'></div>");
    }
  
    // add the btn filter
    if (filterWrapper && !btnApply) {
      // insert the btn HTML
      filterWrapper.insertAdjacentHTML(
        "afterend",
        "<div class='sq-btn-apply'>Anwenden</div>"
      );
    }
  
    // move the button only if not inside the sq container
    if (!sqContainer.querySelector("#sq-btn-filter")) {
      let elInfo = el.querySelector(".sparq-search-inner .info-bar");
      elInfo.prepend(btnFilter);
    }
  
    // setup close events for all required elements
    overlay = el.querySelector(".sq-overlay");
    btnApply = el.querySelector(".sq-btn-apply");
    filterCrossBtn = el.querySelector(".sq-close");
  
    if (overlay) {
      overlay.removeEventListener("click", window.sq.toggleSidebar);
      overlay.addEventListener("click", window.sq.toggleSidebar);
    }
  
    if (btnApply) {
      btnApply.removeEventListener("click", window.sq.toggleSidebar);
      btnApply.addEventListener("click", window.sq.toggleSidebar);
    }
  
    if (filterCrossBtn) {
      filterCrossBtn.removeEventListener("click", window.sq.toggleSidebar);
      filterCrossBtn.addEventListener("click", window.sq.toggleSidebar);
    }
}

window.sq.filterRemove = (el,opts) =>{
  if(opts.UIType === "dropdown") return;

  let fof = el.querySelector(".sq-container.header-container-fof");
  let filterbtn = el.querySelector(".sq-fil");
	
  if(fof) filterbtn.style.display = "none"; 

}


window.sq.searchheadRemove = (el,opts) => {
  if (window.location.href.indexOf("?q=") > -1) {
      console.log("here");
        let x = document.querySelector('h1.main-page-title');
   console.log(x);
        if(x){x.style.display = "none";}
    }

}


window.sq.onData = (data) => {
  window.sq.badge(data);
  return data;
};



window.sq.badge = (data) => {
  if (!data.results) return;

  data.results
    .filter((x) => x.tags)
    .forEach((x) => {
      const badges = x.tags
        .filter((t) => t.startsWith("Badge:"))
        .map((t) => t.toLowerCase().replace("badge:", ""));

      //console.log("badge is", badges);

      if (badges.length === 0) return;

      if (badges.includes("sale")) {
        x.badge = "sale";
      } else if (badges.includes("online exclusive")) {
        x.badge = "online exclusive";
      } else if (badges.includes("new")) {
        x.badge = "new";
      } else if (badges.includes("best seller")) {
        x.badge = "best seller";
      }
    });

  return data;
};
